import React from 'react';
import Image from '../../../common/image';

const OnlyPlanners = () => {
	return (
		<div className='card myCards'>
			<div className='card-body'>
				<div className='row my-5'>
					<div className='col text-center'>
						<Image
							fileName='icons/warn.svg'
							height='100px'
							className='mb-3'
						/>
						<h4>
							Upgrade your investor cards to planner card or purchase one to activate
							this section.
						</h4>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OnlyPlanners;
